import { Breadcrumbs } from '../../../../AbstractElements';
import Sidebar from './Sidebar';
import MainCard from './MainCard';
import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import i18n from '../../../../i18n';

const JobDetails = () => {
    return (
        <Fragment>
            <Breadcrumbs mainTitle={i18n.t('Dashboard_Breadcrumb_JobDetails')} parent={i18n.t('Dashboard_Breadcrumb_JobSearch')} title={i18n.t('Dashboard_Breadcrumb_JobDetails')} />
            <Container fluid={true}>
                <Row>
                    <Sidebar />
                    <MainCard />
                </Row>
            </Container>
        </Fragment >
    );
};

export default JobDetails;
